import { setShowOrderModal } from '../State/showOrderModal';

export default () => async (dispatch) => {

  dispatch(setShowOrderModal(true));

}